/* lp-product-grid — <lp-product-grid>: tabs, quick add via Cart API (then Impact's variant:add / cart:change so the
   theme's cart drawer opens), GA4 ee_view_item_list / ee_select_item via dataLayer (Analyzify item_id format).
   Never emits add_to_cart — Analyzify sends that from the Customer Events sandbox. */
(function () {
  'use strict';
  if (window.customElements.get('lp-product-grid')) return;

  function money(cents, format) {
    var v = (cents / 100).toFixed(2);
    if (!format) return '$' + v;
    return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, format.indexOf('no_decimals') > -1 ? v.replace(/\.00$/, '') : v);
  }
  function gaPush(event, ecommerce, listId, listName) {
    var dl = (window.dataLayer = window.dataLayer || []);
    dl.push({ ecommerce: null });
    ecommerce.item_list_id = listId; ecommerce.item_list_name = listName;
    dl.push({ event: event, analyzify_source: 'lp-product-grid', ecommerce: ecommerce });
  }
  function itemFor(card, listId, listName) {
    return { item_id: card.dataset.gaId, item_name: card.dataset.gaName, price: parseFloat(card.dataset.gaPrice) || 0, index: parseInt(card.dataset.gaIndex, 10) || 0, item_list_id: listId, item_list_name: listName };
  }

  class LpProductGrid extends HTMLElement {
    connectedCallback() {
      this.listId = this.dataset.gaListId || ''; this.listName = this.dataset.gaListName || '';
      this.format = this.dataset.moneyFormat || '';
      this.valueTiers = (this.dataset.valueTiers || '').split(',').filter(Boolean).map(function (p) { var a = p.split(':'); return { spend: parseFloat(a[0]) * 100, pct: parseFloat(a[1]) }; }).filter(function (t) { return t.spend > 0 && t.pct > 0; }).sort(function (a, b) { return a.spend - b.spend; });
      this.cartSubtotal = parseInt(this.dataset.cartSubtotal, 10) || 0;
      this.cards = Array.prototype.slice.call(this.querySelectorAll('.lp-product-card'));
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-tab][role="tab"]'));
      this.viewed = false;
      if (this.tabs.length) {
        var def = this.dataset.tabDefault || this.tabs[0].dataset.tab;
        var has = this.tabs.some(function (t) { return t.dataset.tab === def; });
        this.setTab(has ? def : this.tabs[0].dataset.tab);
        var self = this;
        this.tabs.forEach(function (t) { t.addEventListener('click', function () { self.setTab(t.dataset.tab); }); });
      }
      this.addEventListener('click', this.onClick.bind(this));
      this.renderPrices();
      this.watchCart();
      var self2 = this;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) { if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); self2.pushView(); } }, { threshold: 0.2 });
        io.observe(this);
      } else { this.pushView(); }
    }
    /* order-value tiers projected against the live cart + one unit (same rule as lp-buy-box) */
    pctFor(unit) { var projected = this.cartSubtotal + unit; var hit = this.valueTiers.filter(function (t) { return projected >= t.spend; }); return hit.length ? hit[hit.length - 1].pct : 0; }
    renderPrices() {
      var self = this;
      this.cards.forEach(function (card) {
        var price = parseInt(card.dataset.price, 10) || 0, compare = parseInt(card.dataset.compare, 10) || 0; if (!price) return;
        var pct = self.pctFor(price), unit = Math.round(price * (1 - pct / 100));
        var el = card.querySelector('[data-lp-price]'); if (!el) return;
        var strike = pct ? price : (compare > price ? compare : 0);
        el.innerHTML = (strike ? '<s>' + money(strike, self.format) + '</s> ' : '') + '<span>' + money(unit, self.format) + '</span>' + (pct ? '<span class="lp-product-card__save">Save ' + pct + '%</span>' : '');
      });
    }
    watchCart() {
      var self = this, seq = 0;
      var refresh = function () { var my = ++seq; fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { if (my !== seq) return; self.cartSubtotal = c.original_total_price || c.total_price || 0; self.renderPrices(); }).catch(function () {}); };
      refresh();
      document.documentElement.addEventListener('cart:change', refresh);
      document.addEventListener('cart:refresh', refresh);
      if (window.LP) window.LP.on('cart-add', refresh);
    }
    setTab(key) {
      this.tabs.forEach(function (t) { t.setAttribute('aria-selected', t.dataset.tab === key); });
      this.cards.forEach(function (c) { c.hidden = !!c.dataset.tab && c.dataset.tab !== key; });
      if (this.viewed) { this.viewed = false; this.pushView(); }
    }
    visibleCards() { return this.cards.filter(function (c) { return !c.hidden; }); }
    pushView() {
      if (this.viewed) return; this.viewed = true;
      var self = this;
      var items = this.visibleCards().map(function (c) { return itemFor(c, self.listId, self.listName); });
      if (items.length) gaPush('ee_view_item_list', { items: items }, this.listId, this.listName);
    }
    onClick(e) {
      var card = e.target.closest('.lp-product-card'); if (!card) return;
      var sw = e.target.closest('[data-lp-swatch]');
      if (sw) { e.preventDefault(); this.swap(card, sw); return; }
      var tog = e.target.closest('[data-lp-quick-toggle]');
      if (tog) { e.preventDefault(); var q = tog.closest('[data-lp-quick]'); var open = !q.classList.contains('is-open'); Array.prototype.forEach.call(this.querySelectorAll('[data-lp-quick].is-open'), function (x) { x.classList.remove('is-open'); x.querySelector('[data-lp-quick-toggle]').setAttribute('aria-expanded', 'false'); }); q.classList.toggle('is-open', open); tog.setAttribute('aria-expanded', open); return; }
      var sizeBtn = e.target.closest('[data-variant-id]');
      if (sizeBtn) { e.preventDefault(); this.add(sizeBtn, card); return; }
      if (e.target.closest('a')) gaPush('ee_select_item', { items: [itemFor(card, this.listId, this.listName)] }, this.listId, this.listName);
    }
    swap(card, sw) {
      var handle = sw.dataset.lpSwatch; if (!handle || handle === card.dataset.handle) return;
      var island = card.querySelector('[data-lp-siblings]'); var data = {};
      try { data = JSON.parse(island ? island.textContent : '{}'); } catch (err) { data = {}; }
      var p = data[handle];
      if (!p) {
        /* first card product is not in its own island: stash it once so we can swap back */
        return;
      }
      if (!card._lpOriginal) {
        var img0 = card.querySelector('.lp-product-card__media img');
        card._lpOriginal = { title: card.querySelector('[data-lp-title]').textContent, url: card.querySelector('[data-lp-link]').getAttribute('href'), available: !card.classList.contains('lp-product-card--sold-out'),
          price: card.querySelector('[data-lp-price]').innerHTML, price_cents: parseInt(card.dataset.price, 10) || 0, compare_cents: parseInt(card.dataset.compare, 10) || 0, image: img0 ? img0.currentSrc || img0.src : '', alt: img0 ? img0.alt : '', ga_id: card.dataset.gaId, sizesHTML: (card.querySelector('[data-lp-size-list]') || {}).innerHTML || '' };
        data[card.dataset.handle] = card._lpOriginal;
      }
      Array.prototype.forEach.call(card.querySelectorAll('[data-lp-swatch]'), function (b) { b.setAttribute('aria-pressed', b.dataset.lpSwatch === handle); });
      card.dataset.handle = handle; card.dataset.gaId = p.ga_id || card.dataset.gaId; card.dataset.gaName = p.title;
      if (p.price_cents !== undefined) { card.dataset.price = p.price_cents; card.dataset.compare = p.compare_cents || 0; }
      card.querySelector('[data-lp-title]').textContent = p.title;
      Array.prototype.forEach.call(card.querySelectorAll('[data-lp-link]'), function (a) { a.setAttribute('href', p.url); });
      var img = card.querySelector('.lp-product-card__media img');
      if (img && p.image) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = p.image; img.alt = p.alt || p.title; }
      this.renderPrices();
      card.classList.toggle('lp-product-card--sold-out', p.available === false);
      var list = card.querySelector('[data-lp-size-list]');
      if (list) {
        if (p.sizesHTML !== undefined) list.innerHTML = p.sizesHTML;
        else list.innerHTML = (p.sizes || []).map(function (v) { return '<button type="button" class="lp-product-card__size" data-variant-id="' + v.id + '"' + (v.available ? '' : ' disabled aria-disabled="true"') + '>' + String(v.label || '').replace('Small', 'S').replace('Medium', 'M').replace('Large', 'L') + '</button>'; }).join('');
      }
    }
    add(btn, card) {
      if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
      var self = this, root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      btn.setAttribute('aria-busy', 'true');
      var sections = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
      var fd = new FormData();
      fd.set('id', btn.dataset.variantId); fd.set('quantity', '1');
      fd.set('sections', sections.join(',')); fd.set('sections_url', root + 'variants/' + btn.dataset.variantId);
      fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          btn.removeAttribute('aria-busy');
          if (!res.ok) { self.error(card, res.json && res.json.description); return; }
          return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            cart.sections = res.json.sections || (res.json.items && res.json.items.length ? res.json.sections : undefined);
            if (!cart.sections) document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1500);
            btn.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: [res.json], cart: cart } }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
            if (window.LP) window.LP.emit('cart-add', { variantId: btn.dataset.variantId, cart: cart });
          });
        })
        .catch(function () { btn.removeAttribute('aria-busy'); self.error(card); });
    }
    error(card, msg) {
      var el = card.querySelector('.lp-product-card__error');
      if (!el) { el = document.createElement('p'); el.className = 'lp-product-card__error'; card.querySelector('.lp-product-card__body').appendChild(el); }
      el.textContent = msg || 'Could not add to cart. Please try again.';
      setTimeout(function () { el.remove(); }, 4000);
    }
  }
  window.customElements.define('lp-product-grid', LpProductGrid);
})();
